import localStorageHelper from "../../../app/localStorage";
import { User } from "../../authentication/models/authTypes";

export const getAuditUserName = (): string => {
  const fromUsername = localStorage.getItem("username")?.trim();
  if (fromUsername) return fromUsername;

  const user = localStorageHelper.getByKey("user") as User | undefined;
  return user?.userName?.trim() ?? "";
};
